module.exports = __webpack_public_path__ + "img/duckount-card.85dddd4b.png";